/**
 * Branded custom domains (browser-side list mirroring master.tenant_domains).
 *
 * Both production domains are custom domains on ONE Azure Static Web App serving ONE
 * frontend build, and the API is reached cross-origin so it never sees the branded
 * hostname automatically. The browser therefore passes its own window.location.hostname
 * to GET /api/public/branding (?domain=...), and the SERVER resolves that hostname to a
 * tenant via tenant_domains and reads the branding from the tenant record.
 *
 * IMPORTANT: the browser sends the HOSTNAME only — never a tenant code. The tenant code
 * differs per environment (Select is 'select_capital' on dev, 'select_africa' on UAT),
 * and the domain->tenant mapping is seeded per environment in the master DB, so resolving
 * by hostname is environment-agnostic and needs no client-side code knowledge.
 *
 * This list is only a fast gate so we don't fire a branding request (that would 404) on
 * local dev, the SWA default *.azurestaticapps.net host, or any un-onboarded domain — on
 * those the app keeps its neutral default branding.
 *
 * KEEP IN SYNC: onboarding a branded domain means adding it BOTH here AND as a
 * tenant_domains row (domain_type='custom') in the master DB (migration
 * M3-008_tenant_branding_domains.sql), AND as an Azure SWA custom domain + an entry in
 * the API's CORS_ORIGIN allow-list.
 */

const BRANDED_DOMAINS = [
  'registry.africanalliance.sz',
  'capitalmanagement.selectafrica.net',
];

/**
 * Return the current branded hostname if this app is being served from one, else null.
 * Used to decide whether to fetch per-tenant branding for the login/landing page.
 */
export const getBrandedHost = (hostname) => {
  const host = (hostname || (typeof window !== 'undefined' ? window.location.hostname : '') || '')
    .toLowerCase()
    .trim();
  if (!host) return null;
  return BRANDED_DOMAINS.includes(host) ? host : null;
};

export default BRANDED_DOMAINS;
